<script lang="ts">
    
    import { getPlatformGeolocationSettingsLink } from "../../Services/geolocation";

</script>

<a href={getPlatformGeolocationSettingsLink()} target="_blank">
    <slot />
</a>
